// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  :endpoint="endpoint + 'image-categories'"
  name="Category"
  parentRoute="categories"
  permissions="image-categories"
  :values="values"
  ></detail-view>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

import QRious from 'qrious'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Description',
                value: 'description'
              },
              {
                name: 'Hidden',
                value: 'hidden',
                type: 'checkbox'
              }
            ]
          ]
        },
        {
          name: 'QR Code',
          items: [
            [
              {
                text: 'QR Code',
                prefix: 'cat:',
                value: 'name',
                component: 'qr-holder',
                type: 'component'
              }
            ]
          ]
        }
      ]
    }
  },

  methods: {
    newCode: function () {
      return new QRious({
        element: this.$refs.qr,
        level: 'H',
        padding: 0,
        size: this.size,
        value: this.tagString
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CategoryEdit.vue?0f93a6ce